<template>
  <ProSpaceRightPanel
    :header="header"
    :loading="loading"
    :has-error="hasError"
    @show-history="showHistoryPanel"
  >
    <template v-if="isMultipleView()" #center>
      <ProSpacePanelBlock v-if="isAllRowsSelected" class="prospace-panel-block--empty" :header="{title: $t('itemsSelectedAll')}">
        <template #header>
          <ProSpaceAction
            :text="$t('clearTxt')"
            @click="clearPanelAll"
          />
        </template>
      </ProSpacePanelBlock>
      <PanelBlockSelectedItems :items="[
             { name: $t('marsPeriodName'), value: 'name', f: (v) => v },
             { name: $t('marsPeriodStatus'), value: 'status', f: (v) => v },
          ]"
      />
    </template>
    <template v-if="selectedCount === 1" v-slot:center>
      <ProSpacePanelBlock :header="headerMarsPeriods">
        <ProSpacePanelBlockList :list="content" :show-view-more="false" />
      </ProSpacePanelBlock>
    </template>
    <template v-if="selectedCount === 1" v-slot:bottom>
      <ProSpacePanelBlock :header="headerBottom">
        <template v-slot>
          <ProSpacePanelBlockList :list="contentBottom" />
        </template>
      </ProSpacePanelBlock>
    </template>
  </ProSpaceRightPanel>
</template>

<script>
import {
  ProSpaceRightPanel,
  ProSpaceTabs,
  ProSpacePanelBlock,
  ProSpacePanelBlockList,
  ProSpaceAction,
  ProSpaceSimpleGrid,
  ProSpaceModal
} from "@prospace/prospace-components-library";
import { MarsPeriodService } from "../../../services/MarsPeriodService";
import { mapGetters } from "vuex";
import {getAMorPM} from "@prospace/prospace-components-library/src/lib-assets/mixins/date";
import {
  useMultiSelectRightPanel,
} from "@composes/multiselect"
import PanelBlockSelectedItems from "@multiselect/PanelBlockSelectedItems"
export default {
  name: "MarsPeriodPanel",
  components: {
    ProSpaceRightPanel,
    ProSpaceTabs,
    ProSpacePanelBlock,
    ProSpacePanelBlockList,
    ProSpaceAction,
    ProSpaceSimpleGrid,
    ProSpaceModal,
    PanelBlockSelectedItems
  },
  props: {
    options: {
      type: Array,
      default: () => {
        return [];
      },
    },
    model: {
      type: Array,
      required: true,
    },
    count: {
      type: Number,
      required: true,
    },
    clude: {
      type: Object,
      required: false,
    },
    isAllRowsSelected: {
      type: Boolean,
      default: false
    },
  },
  setup() {
    const { selectedData, selectedClude, selectedCount, isMultipleView } = useMultiSelectRightPanel()
    return {
      selectedData, selectedClude, selectedCount, isMultipleView
    }
  },
  data() {
    return {
      marsPeriod: null,
      marsPeriodService: new MarsPeriodService(),
      loading: false,
      hasError: false,
      modelModalClude: false
    };
  },
  computed: {
    ...mapGetters({
      userinfo: "userinfoStore/getUserinfo",
      getFormatDateTime: "userinfoStore/getFormatDateTime",
    }),
    headerMarsPeriods() {
      return {
        title: this.$t("overview"),
        isExpand: false,
      };
    },
    headerBottom() {
      return {
        title: this.$t("metaInfTxt"),
        isExpand: true,
      };
    },
    tabs() {
      return [{ name: this.$t("overview"), isActive: true }];
    },
    headerMultiple() {
      return {
        title: this.$t("operations"),
        isExpand: false,
      };
    },
    headerClude() {
      return {
        title: this.$t(`${this.clude.isAll ? "itemsExcluded" : "itemsIncluded"}`),
        counter: this.clude.items.length,
        showCounter: true,
      };
    },
    header() {
      if (this.marsPeriod) {
        return {
          title: this.marsPeriod.name,
          id: this.marsPeriod.id,
          status: this.getStatus(this.marsPeriod.status),
          options: this.options,
          showCounter: false,
        };
      }
      return {
        title: this.$t("itemsSelected"),
        counter: this.selectedCount,
        showCounter: true,
      };
    },
    content() {
      if (this.marsPeriod) {
        return [
          [
            {
              title: this.$t("marsPeriodName"),
              text: this.marsPeriod.name,
            },
          ],
          [
            {
              title: this.$t("marsPeriodStatus"),
              text: this.marsPeriod.status,
            },
          ],
          [
            {
              title: this.$t("blockingAdjustments"),
              text: this.getBlockingAdjustmentsValue(this.marsPeriod.isBlocked),
            },
          ],
          [
            {
              title: this.$t("marsPeriodStartDate"),
              text: new Date(this.marsPeriod.startDate),
              dateFormat: this.userinfo.dateFormat,
            },
          ],
          [
            {
              title: this.$t("marsPeriodEndDate"),
              text: new Date(this.marsPeriod.endDate),
              dateFormat: this.userinfo.dateFormat,
            },
          ],
        ];
      }
      return [];
    },
    contentBottom() {
      if (this.marsPeriod) {
        return [
          [
            {
              title: this.$t("createdByTxt"),
              text: this.marsPeriod.createdBy,
            },
            {
              title: this.$t("updatedByTxt"),
              text: this.marsPeriod.updatedBy,
            },
          ],
          [
            {
              title: this.$t("createdAtTxt"),
              text: this.getFormatDateTime(this.marsPeriod.createdAt) + ' ' + getAMorPM(this.marsPeriod.createdAt, this.userinfo?.timeFormat),
            },
            {
              title: this.$t("lastUpdatedTxt"),
              text: this.getFormatDateTime(this.marsPeriod.lastUpdated) + ' ' + getAMorPM(this.marsPeriod.lastUpdated, this.userinfo?.timeFormat),
            },
          ],
        ];
      }
      return [];
    },
  },
  mounted() {
    this.update();
  },
  watch: {
    selectedData() {
      this.update();
    },
    selectedCount() {
      this.update()
    },
    model() {
      this.update();
    },
    count() {
      this.update()
    }
  },
  methods: {
    update() {
      this.hasError = false;
      try {
        this.getMarsPeriod();
      } catch (e) {
        this.hasError = true;
      }
    },
    getMarsPeriod() {
      if (this.selectedCount === 1) {
        this.loading = true;
        this.marsPeriodService.get(this.selectedData.id).then((res) => {
          this.marsPeriod = res.data;
          this.loading = false;
        });
      }
      this.marsPeriod = null;
    },
    getStatus(status) {
      if (!status) return;
      return {
        type: status === "opened" ? "info" : "success",
        text: status[0].toUpperCase() + status.toLowerCase().slice(1),
      };
    },
    clearPanel() {
      if (!this.isAllRowsSelected && (this.count === this.clude.items?.length)) {
        this.$emit("clear");
      } else if (this.isAllRowsSelected && (this.count > this.clude.items?.length) && this.clude.isAll) {
        this.$emit("clear:excluded");
      } else {
        this.$emit("clear");
      }
    },
    clearPanelAll() {
      this.$emit("clear");
    },
    showHistoryPanel() {
      this.$emit("history", this.marsPeriod);
    },
    getBlockingAdjustmentsValue(value) {
      if (value) {
        return this.$t('yes');
      } else {
        return this.$t('no');
      }
    }
  },
};
</script>

<style scoped></style>
